import getLocalString from "constants/Localization";
import { useCreateOrganizationProposalChecklistItemMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateOrganizationProposalChecklistItem() {
  const [mutation, { loading, data, error }] = useCreateOrganizationProposalChecklistItemMutation({
    refetchQueries: ["organizationProposalChecklistItems"],
  });

  const [createOrganizationProposalChecklistItem, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createOrganizationProposalChecklistItem",
    },
    {
      successMessage: getLocalString("organization.create-checklist-item-success"),
      failureMessage: getLocalString("organization.create-checklist-item-failure"),
    }
  );

  return [createOrganizationProposalChecklistItem, context] as const;
}
